import { Route, Routes } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { CanDeactivateGuard } from '@shared/guards/can-deactivate.guard';

import { CloseSettingsComponent } from './close-settings/close-settings.component';
import { BalanceSheetAccountsComponent } from './close-settings/tabs/balance-sheet-accounts/balance-sheet-accounts.component';
import { ExpenseDefaultsComponent } from './close-settings/tabs/expense-defaults/expense-defaults.component';
import { JeConfigurationComponent } from './close-settings/tabs/je-configuration/je-configuration.component';
import { EdcMappingComponent } from './edc-mapping/edc-mapping.component';
import { ExchangeRatesComponent } from './exchange-rates/exchange-rates.component';
import {
  BalanceSheetAccountsGuard,
  CloseSettingsGuard,
  EdcMappingGuard,
  ExchangeRatesGuard,
  ExpenseDefaultsGuard,
  IntegrationsGuard,
  JEConfigurationGuard,
  StudySpecificationsGuard,
  UserPermissionsGuard,
} from './guards/settings-guards';
import { IntegrationsComponent } from './integrations/integrations.component';
import { SettingsComponent } from './settings.component';
import { SpecificationsComponent } from './specifications/specifications.component';
import { UserPermissionsComponent } from './user-permissions/user-permissions.component';
import { UsersComponent } from './users/users.component';

export const buildSettingsRoutes = (): Route => {
  const enabledRoutes: Routes = [
    { component: UsersComponent, path: ROUTING_PATH.SETTINGS.USERS },
    {
      canActivate: [EdcMappingGuard],
      component: EdcMappingComponent,
      path: ROUTING_PATH.SETTINGS.INVESTIGATOR_SETTINGS,
    },
    {
      canActivate: [ExchangeRatesGuard],
      component: ExchangeRatesComponent,
      path: ROUTING_PATH.SETTINGS.EXCHANGE_RATES,
    },
    {
      canActivate: [IntegrationsGuard],
      component: IntegrationsComponent,
      path: ROUTING_PATH.SETTINGS.INTEGRATIONS,
    },
    {
      canActivateChild: [CloseSettingsGuard],
      children: [
        {
          canActivate: [ExpenseDefaultsGuard],
          canDeactivate: [CanDeactivateGuard],
          component: ExpenseDefaultsComponent,
          path: ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.EXPENSE_DEFAULTS,
        },
        {
          canActivate: [JEConfigurationGuard],
          canDeactivate: [CanDeactivateGuard],
          component: JeConfigurationComponent,
          path: ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.JE_CONFIGURATION,
        },
        {
          canActivate: [BalanceSheetAccountsGuard],
          canDeactivate: [CanDeactivateGuard],
          component: BalanceSheetAccountsComponent,
          path: ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.BALANCE_SHEET_ACCOUNTS,
        },
        {
          path: '**',
          redirectTo: ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.EXPENSE_DEFAULTS,
        },
      ],
      component: CloseSettingsComponent,
      path: ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.INDEX,
    },
    {
      canActivate: [UserPermissionsGuard],
      canDeactivate: [CanDeactivateGuard],
      component: UserPermissionsComponent,
      path: ROUTING_PATH.SETTINGS.USER_PERMISSIONS,
    },
    {
      canActivate: [StudySpecificationsGuard],
      component: SpecificationsComponent,
      path: ROUTING_PATH.SETTINGS.STUDY_SPECIFICATIONS,
    },
  ];

  return {
    canDeactivate: [CanDeactivateGuard],
    children: [...enabledRoutes, { path: '**', redirectTo: ROUTING_PATH.SETTINGS.USERS }],
    component: SettingsComponent,
    path: ROUTING_PATH.SETTINGS.INDEX,
  };
};
